import { useFlowStore } from '@/store/flowStore'
import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

const WelcomeRoute = lazyRouteComponent(() => import('@/features/welcome/Welcome'), 'Welcome')

export const Route = createFileRoute('/consentimento')({
  component: WelcomeRoute,
  beforeLoad: () => {
    const { selectedObjectives } = useFlowStore.getState()
    if (selectedObjectives.length === 0) {
      throw redirect({ to: '/objetivo' })
    }
  },
})
